// extracted by mini-css-extract-plugin
export var downArrow = "_is-0";
export var infoTooltipIcon = "_is-3";
export var label = "_is-1";
export var optionCard = "_is-4";
export var upArrow = "_is-2";